import { AfterViewInit, Component, EventEmitter, OnInit, Output, input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { ReportService } from 'src/app/services/report.service';
import { ReportForest } from 'src/app/models/reportForest.model';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { ForestTreament } from 'src/app/models/forestTreatment.model';
import { TreamentSpecification } from 'src/app/models/forestSpecification.model';

@Component({
    selector: 'app-view-emergency-stabilization',
    templateUrl: './view-emergency-stabilization.component.html',
    styleUrls: ['./view-emergency-stabilization.component.scss'],
    standalone: false
})


export class ViewEmergencyStabilizationComponent implements OnInit, AfterViewInit {

  pre_assessment_report: any;
  gis_specialist: any;
  @Output() loaded = new EventEmitter();
  report = input.required<any>();
  treatmentOptions: any;


  form = this.formBuilder.group({
    assessment_cost: [0],
  });
  displayedColumns = [
    'types',
    'treatment',
    'spec_number',
    'spec_name',
    'off_nfs',
    'outside_fire',
    'unit_type',
    'unit_qty',
    'unit_cost',
    'total'
  ]
  footerDisplayedColumns = [
    'types',
    'total'
  ]
  forestTreatments: any;
  totalRequested = 0;

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly toast: ConfirmationToastComponent,
  ) {

  }

  ngOnInit() {
    if(this.report().report_num == 1) this.loadPre(); //only load pre-assessment data on initial
    this.reportService.getTreatmentOptions().subscribe((options: any) => {
      this.treatmentOptions = options
      this.form.patchValue({
        assessment_cost: this.report().assessment_cost,
      })
      this.report().forests.forEach((forest: ReportForest & { data: any[] }) => {
        forest.data = []
        forest.treatments!.forEach((treatment: ForestTreament) => {
          this.setTreatments(treatment, forest);
        })
      });
      this.totalRequestedCalc();
      this.loaded.emit(6);
    });
  }

  loadPre() {
    this.reportService.getReportList(this.report().assessment_id,"&relations=forests.treatments.treatment_specifications").subscribe((data:any) => {
      this.pre_assessment_report = data.reports.find((report:any) => report.report_num == 0);
    })
    this.report().users.forEach((user:any) => {
      let skill_found = user.skills.find((skill:any) => skill.skill_id == 4); //GIS
      if(skill_found) this.gis_specialist = user;
    })
  }

  ngAfterViewInit(): void {
    // this.loaded.emit(6);
  }

  setTreatments(treatment: any, forest: any) {
    let options = this.treatmentOptions.find((option: any) => option.treatment_option_id == treatment.treatment_option_id)

    treatment.treatment_specifications!.forEach((spec: TreamentSpecification) => {
      forest.data.push({
        type: options?.treatment_type?.treatment_type,
        treatment: options?.treatment_option,
        spec_number: spec.specification_number,
        spec_name: spec.specification_name,
        off_nfs: spec.treatment_off_nfs_land,
        outside_fire: spec.treatment_outside_fire,
        unit_type: options?.unit_of_measure,
        unit_qty: spec.custom_unit_qty ?? spec.gis_unit_qty,
        unit_cost: spec.unit_cost,
        from_GIS: spec.from_GIS
      })
    })
    console.log(forest.data)

    forest.data.sort((a: any, b: any) => a.spec_number < b.spec_number ? -1 : 1);
    forest.data.sort((a: any, b: any) => a.treatment < b.treatment ? -1 : 1);
  }

  unitTotal(item: any) {
    return item.unit_cost * item.unit_qty;
  }

  forestTotal(forest: ReportForest & { data: any[] }) {
    let total = 0;
    if (forest.data)
      for (let item of forest.data) {
        total += this.unitTotal(item);
      }
    return total;
  }

  totalRequestedCalc() {
    let total = 0;
    for (let forest of this.report().forests) {
      total += this.forestTotal(forest);
    }
    this.totalRequested = total;
  }
}
